import page from '@root/catalogs/courses.vue';
import createPage from '@root/components/page-common';

createPage(page);